import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../../app/store';

const receiptsSelector = (state: RootState) => state.receipts;

export const getReceipts = createSelector(receiptsSelector, (state) => state.receipts);

export const getReceiptById = (receiptId: string) =>
  createSelector(receiptsSelector, (state) => state.receipts.find((p) => p.id === receiptId));
